import UpdateReqs from './UpdateReq';

export default UpdateReqs;
